import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import SimpleReactValidator from 'simple-react-validator';

import HeaderText from '../../components/personal/HeaderText';
import SetTitle from '../../components/personal/SetTitle';
import DestinationSwitch from '../../utilities/generic/DestinationSwitch';
import PersonFields from '../../components/shared/PersonFields';

import { handleChange } from '../../utilities/generic/Forms.js'
import { handleAutocomplete, handlePersonSubmit, displayAutocompletePersonForSelecting, displayAutocreateNotAllowedMessage } from '../../utilities/personal/Forms.js'

class Leaving extends Component {

  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator();

    this.handleAutocomplete = handleAutocomplete.bind(this);
    this.handleChange = handleChange.bind(this);
    this.handlePersonSubmit = handlePersonSubmit.bind(this);
  }

  state = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    feedback_answer_times: null,
    app_id: "",
    autocompleteDetails: {},
    autocomplete: false,

    autoCreateMessage: false,

    updated: "",
    errors: "",
    error: "",
    direction: "leaving"
  }

  render() {
    if (this.props.location.state === undefined) {
      return <Redirect to="/personal/404" />
    }

    let profile = this.props.location.state.profile
    let token = this.props.location.state.token
    let previous_page = this.props.location.state.previous_page

    const { first_name, last_name, email, phone, feedback_answer_times, updated, errors, error } = this.state;
    let person = { feedback_answer_times }

    const destinationSwitch = new DestinationSwitch({ current_page: "leaving", profile: profile, person: person, leaving_app_id: this.state.app_id, direction: "leaving", token: token, personal: true });

    if (updated) {
      return destinationSwitch.redirect()
    }

    const submit_button_value = destinationSwitch.buttonName()

    if (errors) {
      return (
        <div className="errors">
          Sorry, looks like you have some errors:
          <ul>
            {errors.errors.map((error) => (
              <li>{error}</li>
            ))}
          </ul>
        </div>
      )
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    return (
      <div className="main-page arriving-page back-button">
        <SetTitle title={"Leaving"} profile={profile} />
        <HeaderText message={profile.welcome_message} />

        <div className="content">
          <div className="widget form">
            <form autoComplete="off" onSubmit={this.handlePersonSubmit}>
              <div className="message">
                {profile.text_on_check_out}
              </div>

              <PersonFields
                profile={profile} personal={true}
                first_name={first_name} last_name={last_name} email={email} phone={phone}
                handleChange={this.handleChange} validator={this.validator}
              />

              <br />
              <input type="submit" value={submit_button_value} />
            </form>

            {displayAutocompletePersonForSelecting(this)}

            {displayAutocreateNotAllowedMessage(this)}
          </div>
        </div>

        <div className="back">
          {previous_page === "profiles" ? (
            <Link to={{ pathname: `/personal/new/${encodeURIComponent(token)}`, search: "?page=home" }} className="widget">
              Back
            </Link>
          ) : (
            <Link to={{ pathname: `/personal/new/${encodeURIComponent(token)}` }} className="widget">
              Back
            </Link>
          )}
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (this.props.location.state === undefined) {
      return
    }

    let token = this.props.location.state.token

    let cookies = new Cookies()
    let person_token = cookies.get('person_token')

    if (person_token !== undefined) {
      var headers = new Headers();
      headers.append("Content-Type", "application/json");

      var json = JSON.stringify({
        "personal": {
          "token": token,
          "person_token": person_token,
          "profile_id": this.props.location.state.profile.id,
          "type_of_person": this.props.location.state.profile.type_of_person
        }
      })

      var requestOptions = {
        method: 'POST',
        headers: headers,
        body: json,
        redirect: 'follow'
      };

      var errorsInResponse = false

      fetch(`${process.env.REACT_APP_ROOT_DOMAIN}/v1/d/personal/person_check`, requestOptions)
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          else if (response.status === 401 || response.status === 422) {
            errorsInResponse = true
            return response.json();
          }
          else {
            throw new Error('Something went wrong ...');
          }
        })
        .then(data => {
          if (errorsInResponse) {
            let cookies = new Cookies()
            cookies.remove('person_token', { path: '/', domain: process.env.REACT_APP_COOKIE_DOMAIN })
          } else {
            this.setState({
              autocompleteDetails: data,
              autocomplete: true,
              loaded: true
            })
          }
        })
        .catch(error => this.setState({ error: error, loaded: true }))
    }
  }
}

export default Leaving;
